// extracted by mini-css-extract-plugin
export var chip = "_9d-0";
export var filterDropdown = "_9d-5";
export var filterItem = "_9d-6";
export var icon = "_9d-1";
export var removeButton = "_9d-3";
export var removeIcon = "_9d-4";
export var separator = "_9d-2";